

import axios from 'axios'
import Vue from 'vue';
import router from './../router';
import store from './../store';
import { Message } from 'element-ui';
// axios响应拦截器|
axios.defaults.baseURL = '/admin'
axios.defaults.withCredentials = true
const b = axios.crossDomain = true;
axios.interceptors.response.use(function (response, error) {

	if (response.data.code == 1000) {
		if (response.data.msg != '') {
			Message.success(response.data.msg);
		}
	} else if (response.data.code == 7005) {
		Message.error(response.data.msg);

		localStorage.removeItem("login");
		localStorage.removeItem("tags");
		store.commit('login', false)
		router.push('/login')

	} else {
		Message.error(response.data.msg);
	}
	return response;
}, function (error) {
	// 对响应错误做点什么
	return Promise.reject(error);
});

axios.interceptors.request.use(config => {

	config.headers.Accept = 'application/vnd.api.v1+json';
	const token = JSON.parse(localStorage.getItem('token'));
	config.headers['Authorization'] = 'Bearer ' + token;
	return config;
})
export default axios



// WEBPACK FOOTER //
// ./src/api/index.js